'use strict';

import $ from 'jquery';

// loading

// $(window).on('load', function() {
//     $('.loading')
//         .delay(500)
//         .fadeOut(400, () => {
//             $('.loading').css('display', 'none');
//         });
//     $('#contents')
//         .delay(500)
//         .css('display', 'block');
// });

// animation

$(window).on('load', function() {
    // console.log($thisOffset);
    // 特定の要素を超えた
    $('.js-animation').each((i, e) => {
        const $this = $(e);
        const $thisOffset = $this.offset().top;
        if ($(window).scrollTop() + $(window).height() > $thisOffset) {
            $this.addClass('is-visible');
        }
    });
});

$(window).scroll(function() {
    // console.log($thisOffset);
    // 特定の要素を超えた
    $('.js-animation').each((i, e) => {
        const $this = $(e);
        // const $thisOuter = $this.outerHeight() * 1.2;
        // const $thisOffset = $this.offset().top + $thisOuter;
        const $thisOffset = $this.offset().top + $(window).height() * 0.2;
        if ($(window).scrollTop() + $(window).height() > $thisOffset) {
            $this.addClass('is-visible');
        }
    });
});

